import MDButton from 'components/MDButton'
import React, { useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices, useUploadImage } from 'hook/services'
import { useAgencyInfo } from 'context/agency'
import { Button, Stack } from '@mui/material'
import Editor from 'components/editor'
import { useParams } from 'react-router-dom'

const CreateModal = ({ handleRefresh, sections }) => {
  const uploadImage = useUploadImage()
  const [agency] = useAgencyInfo()
  const { page_id, type } = useParams()
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [description, setDescription] = useState('')

  const handleModal = () => setOpenAddProduct(true)
  const closeAddProduct = () => setOpenAddProduct(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)
    let image_response;
    if (e.target?.image?.files?.[0]) {
      image_response = await uploadImage({
        file: e.target?.image?.files?.[0],
        desiredPath: `app/logo/image`,
      })
    }

    const payload = {
      section_id: page_id,
      chapter_name: e.target.chapter_name.value,
      points: e.target.points.value,
      award_name: e.target.award_name.value,
      award_description: description,
      image: image_response?.response.data ? image_response?.response.data : "",
      type: type,
      status: e.target.status.value,
      priority: e.target.priority.value,
    }

    const { response } = await AppService.questions_sections.create({ payload })

    if (response) {
      setProcessing(false)
      closeAddProduct()
      handleRefresh()
    }
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create
      </MDButton>
      <MDModal open={openAddProduct} onClose={closeAddProduct}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Create Category
            </MDTypography>
            {/* <MDBox mb={2}>
              <MDTypography variant="button">section</MDTypography>
              <MDInput
                select
                name="section_id"
                fullWidth
                required
                SelectProps={{ native: true }}
              >
                <option value="">Select a section</option>
                {sections.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </MDInput>
            </MDBox> */}

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="chapter_name" fullWidth required />
            </MDBox>
            <MDBox mb={2}>
              <MDTypography variant="button">Award Name</MDTypography>
              <MDInput label="Award Name" name="award_name" fullWidth required />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Award Descritpion</MDTypography>
              <Editor handleChange={setDescription} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Points</MDTypography>
              <MDInput label="Points" name="points" fullWidth required />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">priority</MDTypography>
              <MDInput label="priority" name="priority" fullWidth required />
            </MDBox>
            {/* <MDBox mb={2}>
              <MDTypography variant="button">Type</MDTypography>
              <MDInput
                select
                name="type"
                fullWidth
                required
                SelectProps={{ native: true }}
              >
                <option value="User">User</option>
                <option value="Location">Location</option>
                <option value="Agency">Agency</option>

              </MDInput>
            </MDBox> */}
            <MDBox mb={2}>
              <MDTypography variant="button">Status</MDTypography>
              <MDInput select name="status" fullWidth required SelectProps={{ native: true }}
              defaultValue="Publish"
              >
                <option value="Publish">Publish</option>
                <option value="Draft">Draft</option>
              </MDInput>
            </MDBox>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                Upload Image +
                <input hidden name="image" type="file" />
              </Button>
            </Stack>






            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeAddProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default CreateModal